// extracted by mini-css-extract-plugin
export default {"predefinedButton":"header_predefinedButton__9j6L5"};